import {linkImageAsColor} from "#material/nodes/converter/rgb-to-bw/validation"
import {optionalMaterialInput} from "#material/nodes/base/connection/validation/parameters"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {ExchangeNodeName} from "#material/exchange/node-name"
import {materialColorOutput} from "#material/nodes/base/material/validation/io"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {color, versionChain} from "@cm/graph-v3"
import {z} from "zod/v4-mini"

export interface RgbToBwSockets extends MaterialNodeSockets {
    inputs: {
        color: "color" // found in inputs: color; found in settings: color; inferred from data: float3
    }
    settings: {
        color: "color" // found in inputs: color; found in settings: color; inferred from data: float3
        val: "float" // found in inputs: -; found in settings: float; inferred from data: float
    }
    outputs: {
        val: "color"
    }
}

export const rgbToBwDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeRGBToBW,
    },
    nodeClass: "RgbToBw",
    versionChain: versionChain([linkImageAsColor]),
    ui: {
        label: "RGB to BW",
        color: "#4987af",
        items: [
            {name: "val", valueType: "color", label: "Value", output: true},
            {name: "color", valueType: "color", label: "Image", input: true, setting: true, defaultValue: {r: 0.0, g: 0.0, b: 0.0}},
        ],
        support: {
            cycles: true,
            three: true,
        },
    },
    validation: {
        returns: z.strictObject({val: materialColorOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({color: optionalMaterialInput}),
            settings: z.strictObject({color: z.optional(color), val: z.optional(z.number())}),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<RgbToBwSockets>
